import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface EditorPanelState {
  isPlaceholderPanelOpen: boolean;
  togglePlaceholderPanel: () => void;
  setPlaceholderPanelOpen: (open: boolean) => void;
  isSidebarOpen: boolean;
  openSidebar: () => void;
  closeSidebar: () => void;
  toggleSidebar: () => void;
  reset: () => void;
}

export const useEditorPanelStore = create<EditorPanelState>()(
  devtools(
    (set) => ({
      isPlaceholderPanelOpen: true,
      togglePlaceholderPanel: () =>
        set((state) => ({
          isPlaceholderPanelOpen: !state.isPlaceholderPanelOpen,
        })),
      setPlaceholderPanelOpen: (open) => set({ isPlaceholderPanelOpen: open }),
      isSidebarOpen: false,
      openSidebar: () => set({ isSidebarOpen: true }),
      closeSidebar: () => set({ isSidebarOpen: false }),
      toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
      reset: () => set({ isPlaceholderPanelOpen: true, isSidebarOpen: false }),
    }),
    { name: "EditorPanelStore" },
  ),
);
